// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Ig6U","dragIcon":"SortableItem_dragIcon__2hxPr","disabled":"SortableItem_disabled__38hKx"};